import { render } from "./NewInventoryModal.vue?vue&type=template&id=a26ae3d2"
import script from "./NewInventoryModal.vue?vue&type=script&lang=js"
export * from "./NewInventoryModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__